import { useContext, useEffect, useRef, useState } from "react";
import React from "react";
import { api } from "../../services/api";
import { Box, Button, Grid, Typography } from "@mui/material";
import { AuthContext } from "../../contexts/AuthContext";
import { useReactToPrint } from "react-to-print";
import bannertop from "../../assets/bannertop.png";
import PrintIcon from "@mui/icons-material/Print";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import CardHeaderPreviewPdf from "../../components/generic/cardHeaderPreviewPdf";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PrintPdfWarning from "../../components/generic/modalPrintPdfWarning";
import { apiUrl } from "../../services/apiUrl";
import notImage from "../../assets/sem-foto.png";

export default function PreviewPdfEstatiscAnalitic() {
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const { user } = useContext(AuthContext);
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const userPdfEmit = user.email;
  const agora = new Date().toLocaleDateString("pt-Br");
  const [modal, setModal] = useState(false);
  const [visiblePdf, setVisiblePdf] = useState(false);
  // const dados = JSON.parse(localStorage.getItem("PreviewPDFFilter"));

  // dados.map(el => {

  //   if (el.CNPJ.length > 11) {
  //     el.CNPJ = el.CNPJ.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
  //   } else {

  //     el.CNPJ = el.CNPJ.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  //   }
  // })
  const [data, setData] = useState([]);
  const analyticsTable = useRef();


  const enterprise = JSON.parse(localStorage.getItem("PreviewPDFClient"))
  const rows = (23 - (enterprise.length - 1))

  const visibleLegend = enterprise.length > 1

  useEffect(() => {
    const result = localStorage.getItem("PreviewPDF");

    const idEnterprise = JSON.parse(
      localStorage.getItem("PreviewPDFenterprise")
    );
    getResumo(idEnterprise);
  }, []);

  const getResumo = async (enterpriseSelected) => {
    handleLoading(true);
    try {
      const idClient = enterpriseSelected;
      let data = {
        id_client: idClient,
      };
      // const { data: response } = await api({
      //   method: "POST",
      //   url: "/source/resumo",
      //   data,
      // });
      const filter = localStorage.getItem("PreviewPDFFilter");

      const { data: response } = await api({ method: "GET", url: "/source/analiticoPdf/" + idClient + "?&" + filter });

      setData(response.results);
      // filterAnalytics(filter, response.results);
      handleLoading(false);
    } catch (err) {
      console.log(err);
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
  };

  const filterAnalytics = async (result, response) => {
    Object.keys(result).forEach((element) => {
      if (Object.keys(result[element]).length == 0) {
        delete result[element];
      }
    });
    response.forEach((element, index) => {
      element.id = index;
      element.data_entrada = new Date(element.data_entrada)
        .toISOString()
        .split("T")[0];
      element.data_acordo = new Date(element.data_acordo)
        .toISOString()
        .split("T")[0];
      element.vencimento = new Date(element.vencimento)
        .toISOString()
        .split("T")[0];
      element.data_finalizacao = new Date(element.data_finalizacao)
        .toISOString()
        .split("T")[0];
      element.CNPJ = element.CNPJ.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    });
    let thirdArray = response;

    Object.keys(result).forEach((key) => {
      if (result[key]) {
        if (
          key == "devedor" ||
          key == "contrato" ||
          key == "CNPJ" ||
          key == "titulo" ||
          key == "id_estagio"
        ) {
          thirdArray = thirdArray.filter((r) => result[key].includes(r[key]));
        } else if (
          key == "data_entrada" ||
          key == "data_acordo" ||
          key == "vencimento" ||
          key == "data_finalizacao"
        ) {
          if (result[key]["DateStart"] && result[key]["DateEnd"]) {
            thirdArray = thirdArray.filter(
              (r) =>
                Date.parse(result[key]["DateStart"]) <= Date.parse(r[key]) &&
                Date.parse(result[key]["DateEnd"]) >= Date.parse(r[key])
            );
          } else if (result[key]["DateStart"] && !result[key]["DateEnd"]) {
            thirdArray = thirdArray.filter(
              (r) => Date.parse(result[key]["DateStart"]) <= Date.parse(r[key])
            );
          } else if (!result[key]["DateStart"] && result[key]["DateEnd"]) {
            thirdArray = thirdArray.filter(
              (r) => Date.parse(result[key]["DateEnd"]) >= Date.parse(r[key])
            );
          }
        } else {
          thirdArray = thirdArray.filter(
            (r) => result[key][0] <= r[key] && result[key][1] >= r[key]
          );
        }
      }
    });
    thirdArray.forEach((element, index) => {
      element.data_entrada_label = element.data_entrada
        .split("-")
        .reverse()
        .join("/");
      element.data_acordo_label = element.data_acordo
        .split("-")
        .reverse()
        .join("/");
      element.vencimento_label = element.vencimento
        .split("-")
        .reverse()
        .join("/");
      element.data_finalizacao_label = element.data_finalizacao
        .split("-")
        .reverse()
        .join("/");
    });

    //gera tabela
    // setData(thirdArray);
  };

  const handlePdf = useReactToPrint({
    content: () => analyticsTable.current,
  });

  const MakePdf = async () => {
    handleLoading(true);
    setVisiblePdf(true);
    await sleep(2000);

    handlePdf();
    await sleep(500);
    setVisiblePdf(false);
    handleLoading(false);
  };

  const a = data.length / rows;
  const numberRows = Math.ceil(a);
  const headCells = GrafTableHead();
  const versuoHeader = HeaderVersuo();

  var firstArr = [];
  const qtdRows = [...Array(rows).keys()]

  for (let i = 0; i < numberRows; i++) {
    firstArr.push("");
  }

  if (data.length == +1) {
    qtdRows.pop()
  }

  return (
    <Box component="main" sx={{ flexGrow: 1, p: 5, height: '100vh', overflow: 'auto' }}>
      <Grid
        container
        spacing={2}
        justifyContent={"space-between"}
      >
        <Grid item xs={"auto"}>
          <Typography
            sx={{ fontSize: 20, color: "#4B4B4B" }}
          >
            Visualização de impressão
          </Typography>
        </Grid>
        <Grid item xs={"auto"}>
          <Button
            color="buttonPdf"
            onClick={() => setModal(true)}
            sx={{ background: "rgb(0, 50, 160) !important" }}
          >
            <PrintIcon sx={{ color: "white" }} />
          </Button>
          <PrintPdfWarning
            handleClose={() => {
              setModal(false);
            }}
            open={modal}
            handlePDFEmit={() => {
              MakePdf();
              setModal(false);
            }}
          ></PrintPdfWarning>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ overflowX: "auto", display: "flex", justifyContent: "center" }}>
        <div style={{ display: "inline-block", flexDirection: "column", alignItems: "center" }} ref={analyticsTable}>
          <Box p={4}>
            {data.length > 0 &&
              firstArr.map((t, i) => {
                return (
                  <Box
                    sx={{ display: i !== 0 ? "inline-block" : "" }}
                  >
                    {HeaderVersuo()}
                    <Table
                      sx={{ tableLayout: "fixed", marginTop: "15px" }}
                    >
                      {GrafTableHead()}
                      {qtdRows.map((x, j) => {
                        var position = i * rows + j;
                        if (data.length > position) {
                          const title = (enterprise?.findIndex(el => el.cre_id === data[position].credor_id) + 1)
                          return (
                            <TableBody>
                              <TableRow key={data[position]?.name} sx={{ height: "24px" }}>
                                {visibleLegend &&
                                  <TableCell
                                    sx={{
                                      backgroundColor: "white",
                                      border: 0.5,
                                      borderRight: 1.5,
                                      borderLeft: 1.5,
                                      borderColor: "#01A7E1",
                                      fontSize: "0.6rem",
                                      padding: "2.5px",
                                      textAlign: "start",
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                    }}
                                  >
                                    {title}
                                  </TableCell>
                                }
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2.5px",
                                    textAlign: "start",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {data[position].CNPJ}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "start",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',

                                  }}
                                >
                                  {data[position]?.devedor}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "center",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {data[position]?.contrato}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "start",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',

                                  }}
                                >
                                  {data[position]?.id_estagio}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    textAlign: "start",
                                    padding: "2px",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',

                                  }}
                                >
                                  {data[position]?.motivo}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "center",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {data[position]?.data_entrada ? new Date(
                                    data[position]?.data_entrada
                                  ).toLocaleDateString("pt-Br") : null}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "center",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {data[position]?.titulo}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "center",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {new Date(
                                    data[position]?.vencimento
                                  ).toLocaleDateString("pt-Br")}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "end",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >

                                  {data[position]?.valor_original ? new Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                  }).format(data[position]?.valor_original) : null}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "end",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {data[position]?.saldo ? new Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                  }).format(data[position]?.saldo) : null}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "end",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {data[position]?.data_acordo ? new Date(
                                    data[position]?.data_acordo
                                  ).toLocaleDateString("pt-Br") : null}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "end",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {data[position]?.id_acordo}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    backgroundColor: "white",
                                    border: 0.5,
                                    borderRight: 1.5,
                                    borderLeft: 1.5,
                                    borderColor: "#01A7E1",
                                    fontSize: "0.6rem",
                                    padding: "2px",
                                    textAlign: "center",
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                  }}
                                >
                                  {data[position]?.data_finalizacao ? new Date(
                                    data[position]?.data_finalizacao
                                  ).toLocaleDateString("pt-Br") : null}
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          );
                        }
                      })}
                    </Table>
                    {FooterVersuo(i, numberRows)}
                  </Box>
                );
              })}
          </Box>
        </div>
      </Grid>
    </Box>
  );
}

export function GrafTableHead() {


  const enterprise = localStorage.getItem("PreviewPDFClient");

  const visibleLegend = JSON.parse(enterprise).length > 1

  return (
    <TableHead>
      <TableRow>
        {visibleLegend &&
          <TableCell
            sx={{
              fontWeight: "bold",
              paddingBlock: "4px",
              backgroundColor: "#EAEDF5",
              border: 1.5,
              borderColor: "#01A7E1",
              fontSize: "0.7rem",
              padding: "0px",

            }}
            align="center"
          >
            Credor
          </TableCell>
        }
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0px",

          }}
          align="center"
        >
          CNPJ/CPF
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0px",
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
          align="center"
        >
          Cliente/Devedor
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0",
          }}
          align="center"
        >
          Contrato
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0",
          }}
          align="center"
        >
          Estágio
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0",
          }}
          align="center"
        >
          Motivo
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0",
          }}
          align="center"
        >
          Entrada
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0",
          }}
          align="center"
        >
          Título
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "1px",
          }}
          align="center"
        >
          Vencimento
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0",
          }}
          align="center"
        >
          Valor Original
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0",
          }}
          align="center"
        >
          Saldo
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0",
          }}
          align="center"
        >
          Acordo
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0",
          }}
          align="center"
        >
          Id do Acordo
        </TableCell>
        <TableCell
          sx={{
            fontWeight: "bold",
            paddingBlock: "4px",
            backgroundColor: "#EAEDF5",
            border: 1.5,
            borderColor: "#01A7E1",
            fontSize: "0.7rem",
            padding: "0",
          }}
          align="center"
        >
          Finalização
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

export function FooterVersuo(aqui, fim) {
  const { user } = useContext(AuthContext);
  const userPdfEmit = user.email;
  const agora = new Date().toLocaleDateString("pt-Br");
  return (
    <>
      <Box
        sx={{
          borderTop: 1,
          marginTop: "10px",
          marginBottom: "30px",
          borderColor: "#01A7E1",
          width: "100%"
        }}
      >
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "5px",
          }}
        >
          <Typography
            sx={{ marginLeft: "25px", fontSize: "0.8rem", color: "grey" }}
          >
            Data da extração: {agora} | Extraído por : {userPdfEmit}
          </Typography>
          <Typography
            sx={{ marginRight: "27px", fontSize: "0.8rem", color: "grey" }}
          >
            Pág.
            {JSON.stringify(aqui + 1)}/{JSON.stringify(fim)}
          </Typography>
        </Grid>
      </Box>
    </>
  );
}

export function HeaderVersuo() {
  const enterprise = localStorage.getItem("PreviewPDFClient");
  let enterpriseWidth;
  JSON.parse(enterprise).length > 3 ? enterpriseWidth = 250 / (JSON.parse(enterprise).length + 2) : enterpriseWidth = 60;
  const visibleLegend = JSON.parse(enterprise).length > 1
  return (
    <>
      <Grid container>
        <Grid item>
          <img src={bannertop} style={{ width: "60%" }}></img>
        </Grid>
        <Grid item>
          <Typography
            sx={{ fontSize: 22, fontWeight: "bold", color: "#4B4B4B" }}
          >
            Relatório Estatístico - Analítico
          </Typography>
          <Typography
            sx={{
              color: "#5E5E5E",
            }}
          >
            Dados do Credor, Interno, Débito, Acordo e Finalização
          </Typography>
        </Grid>

        <Grid item xs={4} style={{ marginRight: "0", marginTop: "15px" }}>
          {JSON.parse(enterprise).map((head, index) => (
            <>
              {/* <Grid item> */}
              <img
                src={
                  !!head?.logo_file
                    ? `${apiUrl}/files/${head.logo_file}`
                    : notImage
                }
                style={{ width: enterpriseWidth, maxHeight: "35px", marginLeft: "2vw", float: "Right" }}
                alt="banner"
              />
              {/* </Grid> */}
            </>
          ))}
        </Grid>

      </Grid>
      {/* <Box
        sx={{
          borderBottom: 1,
          marginBottom: "15px",
          marginLeft: "47px",
          marginRight: "20px",
          borderColor: "#01A7E1",
        }}
      ></Box> */}

      <Grid container sx={{
        borderTop: 1,
        borderBottom: 1,
        borderColor: "#01A7E1",
        marginBottom: "10px"
      }}>
        <Grid item xs={12}>
          <Grid container spacing={2} justifyContent={"space-between"}>
            <Grid item xs={"auto"} sm={"auto"}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold", marginLeft: visibleLegend ? "24px" : "0px" }}>
                Nome Fantasia
              </Typography>
              {JSON.parse(enterprise).map((head, index) => (
                <Box key={index} sx={{ display: "flex" }}>
                  {visibleLegend &&
                    <Typography component={"span"} sx={{ color: "black !important" }}> {index + 1} - </Typography>
                  }
                  <Typography key={index} sx={{ color: "#2C4992", textTransform: "capitalize", marginLeft: visibleLegend ? "4px" : "0px" }}>{head.nome_fantasia}
                  </Typography>
                </Box>
              ))}
            </Grid>
            <Grid item xs={"auto"} sm={"auto"}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                CNPJ
              </Typography>
              {JSON.parse(enterprise).map((head, index) => (
                <Typography key={index} sx={{ color: "#2C4992", textTransform: "capitalize" }}>
                  {head.pes_cpfcnpj}
                </Typography>
              ))}

            </Grid>
            <Grid item xs={"auto"} sm={"auto"}>
              <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                Início das Atividades
              </Typography>
              {JSON.parse(enterprise).map((head, index) => (
                <Typography key={index} sx={{ color: "#2C4992", textTransform: "capitalize" }}>{head.data_inicio}</Typography>
              ))}
            </Grid>
          </Grid>
        </Grid>

      </Grid>
    </>
  );
}
